import React from 'react';
import {CustomDatePicker} from '@softura/fluentuipackage';
import './datepicker.scss';
interface Iprops {
    className?:any,
    value?:any,
    onChangeDate:Function
}
const DatePicker = (
    {
        className='',
        value,
        onChangeDate}
    :Iprops) => {
    return <CustomDatePicker className={className} value={value} onChangeDate={onChangeDate}  />
}

export default DatePicker